import { styled } from '@mui/material/styles'
import { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { Tooltip } from '@mui/material'
import theme from 'theme'

export const SSOTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  zIndex: 100004,

  [`& .${tooltipClasses.tooltip}`]: {
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: '12px',
    lineHeight: '1.4',
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.devicesSecondaryText,
    borderRadius: '12px',
    boxShadow: '0px 4px 8px rgba(30, 26, 29, 0.2)',
    background: theme.colors.tooltipBg,
    padding: '12px',
    maxWidth: '220px'
  }
})
